import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { NavigationComponent } from 'src/app/navigation/navigation.component';
import { FooterComponent } from 'src/app/footer/footer.component';
import { ResponsiveDesignService } from 'src/app/service/responsiveDesign.service';
import {
  NetworkService,
  NetworkStateEvent,
} from 'src/app/service/network.service';

@Component({
  selector: 'app-sensorstation-information',
  templateUrl: './sensorstation-information.component.html',
  styleUrls: ['./sensorstation-information.component.scss'],
  standalone: false,
})
export class SensorstationInformationComponent implements OnInit, OnDestroy {
  private className = 'SensorstationInformationComponent';

  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private responsiveDesignService: ResponsiveDesignService,
    public networkService: NetworkService
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  private nsCallback(eventType: NetworkStateEvent, msg?: any): void {
    switch (eventType) {
      case NetworkStateEvent.CLIENTERROR:
      case NetworkStateEvent.SERVERERROR:
        break;
      default:
        break;
    }
  }

  ngOnInit(): void {
    this.networkService.register(this.className, this.nsCallback.bind(this));
  }

  ngOnDestroy(): void {
    this.networkService.deregister(this.className);
    NavigationComponent.setDisabled(false);
    FooterComponent.setDisabled(false);
    this.responsiveDesignService.deregister(this.className);
  }

  public sectionList = [
    { key: 'overview', title: 'Überblick Immissionen' },
    { key: 'estm', title: 'Environmental Sensitive Traffic Management (ESTM)' },
    { key: 'aqdm', title: 'Air Quality Dispersion Model (AQDM)' },
  ];

  public isSectionOpen: { [key: string]: boolean } = {
    overview: false,
    estm: false,
    aqdm: false,
  };

  public toggleSection(key: string): void {
    this.isSectionOpen[key] = !this.isSectionOpen[key];
  }
}
